import { ActionsBar } from '../ActionsBar/ActionsBar';

export type SampleOrderContentProps = {
  pageContent: React.ReactNode;
  actionBarContent: React.ReactNode;
};

export const SampleOrderContent = ({ pageContent, actionBarContent }: SampleOrderContentProps) => (
  <div className="flex h-full max-h-[100vh] min-h-[50vh] w-full flex-col justify-end overflow-hidden">
    <div className="bg-color-grey-light shrink grow basis-[90%] overflow-x-hidden overflow-y-auto scroll-smooth p-2 lg:p-3">
      {pageContent}
    </div>
    <ActionsBar>{actionBarContent}</ActionsBar>
  </div>
);
